import { render, staticRenderFns } from "./backgroundImg.vue?vue&type=template&id=03037ce8&scoped=true&"
import script from "./backgroundImg.vue?vue&type=script&lang=js&"
export * from "./backgroundImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03037ce8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03037ce8')) {
      api.createRecord('03037ce8', component.options)
    } else {
      api.reload('03037ce8', component.options)
    }
    module.hot.accept("./backgroundImg.vue?vue&type=template&id=03037ce8&scoped=true&", function () {
      api.rerender('03037ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/child/backgroundImg.vue"
export default component.exports